import React, { useEffect, useState } from "react";
import SummaryTable from "./SummaryTable";
import Stats from "./Stats";
import H2h from "../match/Linesup";
import Linesup from "../../common/football/Linesup";
import FootballTable from "./Table";

import InfoTable from "./InfoTable";
import { getData } from "../../../utils/getData";
import NoDataFound from "../../common/NoDataFound";
import News from "../../common/News";
import { loadStyles } from "../../../utils/cssLoader";

const MatchPage = ({
  data,
  baseUrl,
  dataType,
  difference,
  sport,
  dataId,
  commData,
  loadCSS,
  headData,
  setDataType,
  setDataId,
  setHead,
  setLeagueId,
  dataClient,
}) => {
  const [active, setActive] = useState(
    headData?.newtabs?.length > 0 &&
      (headData?.newtabs[0] === "commentary" ||
      headData?.newtabs[0] === "events"
        ? {
            key: "match-summary",
            label: "Match Summary",
          }
        : {
            key: `match-${headData?.newtabs[0]}`,
            label:
              headData?.newtabs[0] === "h2h"
                ? headData?.newtabs[0].toUpperCase()
                : String(headData?.newtabs[0]).charAt(0).toUpperCase() +
                  String(headData?.newtabs[0]).slice(1),
          })
  );
  const [activeTabData, setActiveTabData] = useState(data);
  const [isLoading, setIsLoading] = useState(false);
  const [commentaryData, setCommentaryData] = useState(null);
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    if (headData && headData?.newtabs) {
      setActive(
        headData?.newtabs[0] === "commentary" ||
          headData?.newtabs[0] === "events"
          ? {
              key: "match-summary",
              label: "Match Summary",
            }
          : {
              key: `match-${headData?.newtabs[0]}`,
              label:
                headData?.newtabs[0] === "h2h"
                  ? headData?.newtabs[0].toUpperCase()
                  : String(headData?.newtabs[0]).charAt(0).toUpperCase() +
                    String(headData?.newtabs[0]).slice(1),
            }
      );
      const matchTabs = headData?.newtabs?.flatMap((hdata) =>
        hdata !== "commentary" && hdata !== "events"
          ? [
              {
                key: `match-${hdata}`,
                label:
                  hdata === "h2h"
                    ? hdata.toUpperCase()
                    : String(hdata).charAt(0).toUpperCase() +
                      String(hdata).slice(1),
              },
            ]
          : []
      );
      if (
        headData?.newtabs?.indexOf("commentary") > -1 ||
        headData?.newtabs?.indexOf("events") > -1
      ) {
        matchTabs.unshift({
          key: "match-summary",
          label: "Summary",
        });
      }
      setTabs(matchTabs);
    }
  }, [headData]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("matchpage");
    }
  }, [loadCSS]);

  const fetchData = async () => {
    try {
      if (active?.key) {
        const data =
          active.key === "match-news"
            ? await getData({
                dataId,
                dataType: active.key,
                baseUrl,
                sport,
                newsType: "match",
              })
            : await getData({
                dataId,
                dataType: active.key,
                baseUrl,
                sport,
              });
        if (active.key === "match-summary") {
          const otherData = await getData({
            dataId,
            dataType: "match-com",
            baseUrl,
            sport,
          });
          setCommentaryData(otherData);
        }
        setActiveTabData(data);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (active) {
      fetchData();
    }
  }, [active]);

  return (
    <div className="match-page">
      <div className="detail_page">
        <nav className="detail_main_tab">
          <ul>
            {tabs?.length > 0 &&
              tabs.map(({ key, label }) => (
                <li
                  key={key}
                  className={`${active.key === key ? "active" : ""}`}
                  onClick={() => {
                    if (active.key !== key) {
                      setIsLoading(true);
                      setActive({ key, label });
                      setActiveTabData(null);
                    }
                  }}
                  data-name={key}
                >
                  <button>{label}</button>
                </li>
              ))}
          </ul>
        </nav>
        {isLoading ? (
          <h3>loading...</h3>
        ) : (
          <>
            {active?.key === "match-summary" && (
              <>
                {headData?.newtabs?.indexOf("commentary") > -1 ||
                headData?.newtabs?.indexOf("events") > -1 ? (
                  <SummaryTable
                    data={activeTabData?.summary}
                    commData={commentaryData ? commentaryData : commData}
                    id={dataId}
                  />
                ) : (
                  <NoDataFound />
                )}
              </>
            )}
            {active?.key === "match-stats" && (
              <Stats data={activeTabData?.data} />
            )}
            {active?.key === "match-lineup" && (
              <Linesup data={activeTabData?.data} />
            )}
            {active?.key === "match-table" && (
              <FootballTable data={activeTabData?.data} />
            )}
            {active?.key === "match-h2h" && (
              <H2h
                data={activeTabData?.data}
                setDataType={setDataType}
                setDataId={setDataId}
                setHead={setHead}
                setLeagueId={setLeagueId}
              />
            )}
            {active?.key === "match-info" && (
              <InfoTable
                data={activeTabData?.info || activeTabData?.summary}
                difference={difference}
              />
            )}
            {active?.key === "match-news" && (
              <News
                data={activeTabData?.data}
                id={dataId}
                newsType="match"
                sport={sport}
                baseUrl={baseUrl}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MatchPage;
